module.exports = __webpack_public_path__ + "static/media/jbl.52cb9223.png";